import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';

import { DataService } from '../../e-met/services/data.service';
import { SharedService } from '../../e-met/services/shared.service';
import * as utils from '../../e-met/services/utility-functions';
import { KeyValue } from '@angular/common';
import { CurrencyPipe, DOCUMENT, DatePipe } from '@angular/common';
import { TRANSER_TYPE } from '../shared.interface';
@Component({
    selector: 'app-submitable-table',
    templateUrl: './submitable-table.component.html',
    styleUrls: ['./submitable-table.component.scss'],
})
export class SubmitableTableComponent implements OnInit {
    @ViewChild('inputFile') myInputVariable: ElementRef;
    @Input() tableData: any;
    @Input() additionltableData?: any;
    public returnData;
    public tablePatern;
    public tableName;
    fileToUpload: File = null;
    fileChosen: string;
    fileErrorMessage: string;
    fileSuccessMessage: string;
    documentToUpload;
    submitData = false;

    originalOrder = (
        a: KeyValue<number, string>,
        b: KeyValue<number, string>
    ): number => {
        return 0;
    };

    constructor(
        private dataService: DataService,
        private sharedService: SharedService,
        private currencyPipe: CurrencyPipe
    ) {}

    ngOnInit(): void {
        this.tablePatern = this.tableData?.infoTableData[0]?.data[0];
        this.tableName = this.tableData?.infoTableData[0]?.tableName;

        if (this.tableName == 'propertiesTable') {
            this.preprocessTableData(this.tableData?.infoTableData);
            this.sharedService.propertyListSubmitter$.subscribe((status) => {
                if (status.submit == true) {
                    this.submitProperty(status.panelID);
                }
            });
        }
        if (this.tableName == 'notaryTable') {
            this.sharedService.notaryListSubmitter$.subscribe((status) => {
                if (status.submit == true) {
                    this.submitNotary();
                }
            });
        }
        if (this.tableName == 'propertyTable') {
            this.sharedService.contractListSubmitter$.subscribe((status) => {
                if (status.submit == true) {
                    let cadID = this.tableData?.infoTableData[0]?.cadID;
                    this.submitContract(status.panelID, cadID);
                }
            });
        }
        if (this.tableName == 'partiesInvolved') {
            this.sharedService.involvedPartySubmitter$.subscribe((status) => {
                if (status.submit == true) {
                    this.submitPartiesInvolved(status.panelID);
                }
            });
        }




        // if (this.tableName == 'documentsTable') {
        //     this.sharedService.AttachmentsListSubmitter$.subscribe((status) => {
        //         if (status.submit == true) {
        //             this.submitAttachments();
        //         }
        //     });
        //     this.preselectTypes();
        // }
    }

    /**
     *
     * @param { {[key:string]:any}[]} infoTableData - Info Table Data
     */
    preprocessTableData(infoTableData) {
        infoTableData.forEach((item) => {
            /** @type {any[]} */
            let data = item.data;
            console.log(data);
            data.forEach((d) => {
                const doubleKey = Object.keys(d).find(
                    (key) => d[key]?.type === 'double'
                );
                if (doubleKey && d[doubleKey]?.value.includes('/')) {
                    console.log('Can parse value ', d[doubleKey].value);
                    d[doubleKey].values = (
                        d[doubleKey].value?.split('/') ?? []
                    ).map((val) => {
                        if (val != '0' && !val) {
                            return val;
                        }
                        return isNaN(val) ? null : parseFloat(val);
                    });
                }
            });
        });
    }
    preselectTypes() {
        setTimeout(() => {
            let table = document.querySelector('.documentsTable');
            console.log('TABLE', table);
            if (table) {
                let row = table.querySelectorAll('tbody tr');

                row.forEach((element, index) => {
                    /*
                    let select = element.querySelector('select');
                    if (index == 0) {
                        select.value = '10';
                    }
                    if (index == 1) {
                        select.value = '13';
                    }
                    */
                });
            }
        }, 1000);
    }
    changeSelect($event) {
        if (!$event.target.value) {
            return;
        }
        if ($event.target.name == 'kaek') {
            this.kaekSelect($event);
        }
        if ($event.target.name == 'taxNumber') {
            this.taxNumberSelect($event);
        }
    }
    addRow() {
        this.tableData.infoTableData[0].data.push(this.tablePatern);
    }
    removeRow(id) {
        this.tableData.infoTableData[0].data =
            this.tableData.infoTableData[0].data.splice(1, id);
    }
    getChargesFromFormValues(cadID, $event) {
        let parent = $event.target.parentElement.parentElement;
        let commercialAmount = (<HTMLInputElement>(
            parent.querySelector('#commercialAmount2')
        )).value;
        let objectiveAmount = (<HTMLInputElement>(
            parent.querySelector('#objectiveAmount1')
        )).value;

        let numOfReqCertificates = (<HTMLInputElement>(
            parent.querySelector('input[name=numOfReqCertificates]')
        )).checked
            ? '1'
            : '0';

        if(this.dataService.selectedApplicationType === TRANSER_TYPE.INHERITANCE){
          objectiveAmount = '0';
          commercialAmount = '0';
        }else if(this.dataService.selectedApplicationType === TRANSER_TYPE.PARENTAL || this.dataService.selectedApplicationType === TRANSER_TYPE.DONATION)
          commercialAmount = '0';


        if (objectiveAmount && commercialAmount && objectiveAmount !== '' && commercialAmount !== '') {
          this.sharedService.recalculateChargesObservable({
              cadID: cadID,
              objectiveAmount: utils.getRegexAmountValue(objectiveAmount),
              commercialAmount: utils.getRegexAmountValue(commercialAmount),
              numOfReqCertificates: numOfReqCertificates,
          });
        } else {
          this.dataService.onFailFormFieldsValidation('Για τον υπολογισμό τελών απαιτείται Αντικειμενική Αξία και Τίμημα.');
          return;
        }
    }
    submitNotary() {
        let notaryObject = [];
        let table = document.querySelector('.notaryTable tbody');
        let rows = table.querySelectorAll('tr');
        rows.forEach((element) => {
            notaryObject.push({
                fathersName: (<HTMLInputElement>(
                    element.querySelector('input[name=surname]')
                )).value,
                firstName: (<HTMLInputElement>(
                    element.querySelector('input[name=firstName]')
                )).value,
                idNumber: (<HTMLInputElement>(
                    element.querySelector('input[name=idNumber]')
                )).value,
                seat: (<HTMLInputElement>(
                    element.querySelector('input[name=seat]')
                )).value,
            });
            this.sharedService.updateNotaryListData(notaryObject);
        });
    }
    submitPartiesInvolved(panelID) {
        let partiesObject = [];
        let panel = document.getElementById('panel' + panelID);
        let table = panel.querySelector('.partiesInvolved tbody');
        let rows = table.querySelectorAll('tr');
        rows.forEach((element) => {
            partiesObject.push({
                taxNumber: (<HTMLInputElement>(
                    element.querySelector('input[name=taxNumber]')
                )).value,
                lastName: (<HTMLInputElement>(
                    element.querySelector('input[name=lastName]')
                )).value,
                firstName: (<HTMLInputElement>(
                    element.querySelector('input[name=firstName]')
                )).value,
                fathersName: (<HTMLInputElement>(
                    element.querySelector('input[name=fathersName]')
                )).value,
                citizenRole: (<HTMLInputElement>(
                    element.querySelector('input[name=citizenRole]')
                )).value,
                panelID: panelID,
            });
            this.sharedService.updateInvolvedPartyListData(partiesObject);
        });
    }
    submitProperty(panelID: string) {
        let propertyObject = [];
        let panel = document.getElementById('panel' + panelID);
        let table = panel.querySelector('.propertiesTable tbody');
        let rows = table.querySelectorAll('tr');
        rows.forEach((element) => {
            let kaek = (<HTMLInputElement>(
                element.querySelector('input[name=kaek]')
            )).value;
            let splitValues = kaek.split('/');
            propertyObject.push({
                verticalNumber: splitValues[1],
                horizontalNumber: splitValues[2],
                role: (<HTMLInputElement>(
                    element.querySelector('input[name=citizenRole]')
                )).value,
                address: (<HTMLInputElement>(
                    element.querySelector('input[name=propertyAddress]')
                )).value,
                kaekNumber: splitValues[0],
                ownershipTypeId: '0101',
                description: (<HTMLInputElement>(
                    element.querySelector('input[name=propertyType]')
                )).value,
                taxCode: (<HTMLInputElement>(
                    element.querySelector('input[name=taxNumber]')
                )).value,
                ownershipNominator: (<HTMLInputElement>(
                    element.querySelector('input[name=ownership1]')
                )).value,
                ownershipDenominator: (<HTMLInputElement>(
                    element.querySelector('input[name=ownership2]')
                )).value,
                panelID: panelID,
            });
        });

        this.sharedService.updatePropertyListData(propertyObject);
    }

    submitContract(panelID, cadID) {
        let contractObject = [];
        let panel = document.getElementById('panel' + panelID);
        let table = panel.querySelector('.propertyTable tbody');
        let rows = table.querySelectorAll('tr');
        rows.forEach((element) => {
            contractObject.push({
                transferType: (<HTMLInputElement>(
                    element.querySelector('input[name=transferType]')
                )).value,
                objectiveAmount: (<HTMLInputElement>(
                    element.querySelector('input[name=objectiveAmount]')
                )).value,
                commercialAmount: (<HTMLInputElement>(
                    element.querySelector('input[name=commercialAmount]')
                )).value,
                numOfReqCertificates: (<HTMLInputElement>(
                    element.querySelector('input[name=numOfReqCertificates]')
                )).checked
                    ? '1'
                    : '0',
                panelID: panelID,
                cadOfficeId: cadID,
            });
            this.sharedService.updateContractListData(contractObject);
        });
    }
    kaekSelect($event) {
        let row = $event.target.closest('tr');
        let addressField = row.querySelector('.propertyAddress');
        let descriptionField = row.querySelector('.propertyType');

        this.additionltableData?.forEach((element) => {
            if (element.kaekNumber == $event.target.value) {
                row.querySelector('input[name=propertyAddress]').value =
                    element.address;

                row.querySelector('input[name=propertyType]').value =
                    element.description;
                addressField.innerText = element.address;
                descriptionField.innerText = element.description;
            }
        });
    }
    taxNumberSelect($event) {
        let row = $event.target.closest('tr');
        let role = row.querySelector('.citizenRole');

        this.additionltableData?.forEach((element) => {
            if (element.taxCode == $event.target.value) {
                role.innerText = utils.getBuyerSeller(element.role);
                row.querySelector('input[name=citizenRole]').value =
                    element.role;
            }
        });
    }

    onBlurMethod($event, oldValue) {
      let errorMessage = '';
/*
      if (!$event.target.value) {
          return;
      }
*/
      console.log('name = ', $event.target.name);
      console.log('value = ', $event.target.value);
      console.log('oldValue = ', oldValue);

      let onlyTextRegexMsg = 'θα πρέπει να περιέχει μόνο γράμματα.';
      let textAndNumbersRegexMsg = 'θα πρέπει να περιέχει μόνο γράμματα και αριθμούς.';
      let onlyDateRegexMsg = 'θα πρέπει να έχει τη μορφή ημερομηνίας.';
      let onlyEuroAmountRegexMsg = 'θα πρέπει να περιέχει μόνο αριθμούς και τελείες.';
      let onlyDecimalNumberRegexMsg = 'θα πρέπει να περιέχει μόνο αριθμούς.';
      let onlyNumbersRegexMsg = 'θα πρέπει να περιέχει μόνο ακέραιους αριθμούς.';

      if ($event.target.name == 'ownership1' || $event.target.name == 'ownership2') {
        $event.target.value = ($event.target.value).replace(',','.');
      }

      if ($event.target.name === 'firstName' && !utils.onlyTextRegex($event.target.value)) {
        errorMessage = 'Το Όνομα ' + onlyTextRegexMsg;
      }
      else if ($event.target.name === 'surname' && !utils.onlyTextRegex($event.target.value)) {
        errorMessage += 'Το Επώνυμο ' + onlyTextRegexMsg;
      }
      else if ($event.target.name === 'idNumber' && $event.target.value === '') {
        errorMessage += 'Ο Αρ. Μητρώου θα πρέπει να είναι συμπληρωμένος.';
      }
      else if ($event.target.name === 'seat' && !utils.onlyTextRegex($event.target.value)) {
        errorMessage += 'Η Έδρα ' + onlyTextRegexMsg;
      }
      else if ($event.target.name === 'documentId' && !utils.textAndNumbersRegex($event.target.value)) {
        errorMessage += 'Ο Αρ. Εγγράφου ' + textAndNumbersRegexMsg;
      }
      else if ($event.target.name === 'calendardate' && !utils.onlyDateRegex($event.target.value)) {
        errorMessage += 'Η Ημ/νία Εγγράφου ' + onlyDateRegexMsg;
      }
      else if ($event.target.name === 'documentCadastre' && $event.target.value === '') {
        errorMessage += 'Πρέπει να μεταφορτώσετε Συμβόλαιο.';
      }
      else if ($event.target.name === 'objectiveAmount' && !utils.onlyEuroAmountRegex($event.target.value)) {
        errorMessage += 'Η Αντικειμενική Αξία ' + onlyEuroAmountRegexMsg;
      }
      else if ($event.target.name === 'commercialAmount' && !utils.onlyEuroAmountRegex($event.target.value)) {
        errorMessage += 'Το Τίμημα ' + onlyEuroAmountRegexMsg;
      }
      else if ($event.target.name === 'ownership1' && !utils.onlyEuroAmountRegex($event.target.value)) {
        errorMessage += 'Το Μεταβιβαζόμενο Ποστοστό ' + onlyDecimalNumberRegexMsg;
      }
      else if ($event.target.name === 'ownership2' && !utils.onlyEuroAmountRegex($event.target.value)) {
        errorMessage += 'Το Μεταβιβαζόμενο Ποστοστό ' + onlyDecimalNumberRegexMsg;
      }
      else if ($event.target.name === 'docId' && !utils.onlyNumbersRegex($event.target.value)) {
        errorMessage += 'Ο Κ.Η.Δ. ' + onlyNumbersRegexMsg;
      }

      //console.log('errorMessage = ', errorMessage);

      if (errorMessage !== '') {
        if (oldValue !== 'undefined') {
          $event.target.value = oldValue;
        }
        this.dataService.onFailFormFieldsValidation(errorMessage);
        return;
      }

      if ($event.target.name == 'objectiveAmount' || $event.target.name == 'commercialAmount') {
        $event.target.value = this.currencyPipe.transform(
          ($event.target.value).replace(',','.'),
          'EUR',
          'symbol',
          '1.2-2',
          'es-ES'
        );
      }
    }
}
